import {  Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-manual-redaction',
  templateUrl: './manual-redaction.component.html',
  styleUrls: ['./manual-redaction.component.scss']
})
export class ManualRedactionComponent implements OnInit {
  @Input() documentId: string;
  @Input() documentDetails: string;
  @Input() redactionStatus;
  @Output() openRedactionDialog = new EventEmitter();
  @Output() close = new EventEmitter<boolean>()
  constructor() { }

  ngOnInit() {
  }

  onClose(): void {
    this.close.emit(true)
  }

  onRedact(): void {
    this.openRedactionDialog.emit()
  }

}
